module.exports = __webpack_public_path__ + "static/media/M.4699dac0.jpg";